// extracted by mini-css-extract-plugin
export default {"container":"ViewFormsModal_container__c7Mun"};